import { render, staticRenderFns } from "./terminos.vue?vue&type=template&id=cb71ce90&scoped=true&"
import script from "./terminos.vue?vue&type=script&lang=js&"
export * from "./terminos.vue?vue&type=script&lang=js&"
import style0 from "./terminos.vue?vue&type=style&index=0&id=cb71ce90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb71ce90",
  null
  
)

export default component.exports